<template>
  <PbsActionButton :label="$t('general.moreActions')" :items="actionButtonItems" mod-large />
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PbsActionButton, { PbsActionButtonItem } from '@/components/PbsActionButton.vue';
import SpecificationImportForm from '@/modules/configuration/views/shared/specification-import-form/SpecificationImportForm.vue';
import { useModalStore } from '@/modules/core/store/modal.store';
import { ImportSpecificationType, ProductProcessDefinitionDetailDto } from '@/api/backoffice/clients';

const modalStore = useModalStore();

const { t } = useI18n();

type ProductSpecificationActionButtonProps = {
  detail: ProductProcessDefinitionDetailDto;
  target: ImportSpecificationType.ProductSpecification | ImportSpecificationType.SourceSpecification;
};

const props = withDefaults(defineProps<ProductSpecificationActionButtonProps>(), {
  detail: null,
  target: ImportSpecificationType.ProductSpecification
});

const actionButtonItems = computed((): PbsActionButtonItem[] => {
  return [importSpecificationAction()];
});

const importSpecificationAction = () => {
  return {
    name: 'import',
    label: t('productspecification.actions.import.label'),
    click: () => {
      modalStore.showModal({
        title: t('productspecification.actions.import.description'),
        component: SpecificationImportForm,
        props: {
          definitionId: props.detail.id,
          target: props.target
        }
      });
    },
    ellipsis: true
  };
};
</script>

<style lang="scss" scoped></style>
